export default __webpack_public_path__ + "static/media/BackArrow.36095826.svg";